
const partners = [
  {
    name: 'Avert Network Services',
    category: 'IT/Cybersecurity/Networking',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2021/07/avert-logo.jpg',
    description: 'Avert Network Services helps medical practices stay secure, compliant, and protected from cyber threats. They fill critical IT gaps—from HIPAA readiness to staff training—so your team can focus on patient care without worrying about tech headaches.',
    icon: 'ri-computer-line'
  },
  {
    name: 'Cleod9',
    category: 'VOIP Services',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2021/08/cleod9.png',
    description: 'Cleod9 streamlines communication for medical facilities by unifying calls, video visits, texts, and internal chat into one HIPAA-compliant platform—reducing hold times, missed calls, and front desk overload.',
    icon: 'ri-phone-line'
  },
  {
    name: 'Catalyst by Concentra',
    category: 'HR Consulting Services',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2021/08/catalyst.jpg',
    description: 'Streamline operations, stay compliant, and boost profitability. From HR and healthcare compliance to EMR optimization, budgeting, and patient payment strategies, we deliver hands-on support to make clinics run smoother and more efficiently.',
    icon: 'ri-user-settings-line'
  },
  {
    name: 'Simmons Bank',
    category: 'Private Banking',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2021/08/simmons-bank.png',
    description: 'Simmons Bank provides tailored financial solutions for medical practices, including financing, practice acquisitions, and revenue cycle management. From equipment loans to HIPAA-compliant payment processing, their healthcare banking team helps providers improve cash flow, streamline operations, and plan for long-term growth.',
    icon: 'ri-bank-line'
  },
  {
    name: 'Consultative Minds',
    category: 'CFO Services',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2021/08/Screen-Shot-2025-11-01-at-7.53.52-PM.png',
    description: 'Consultative Minds helps healthcare practices grow sustainably through strategic financial planning, cash flow optimization, and fractional CFO services. From forecasting and expansion modeling to financial reporting and operational efficiency, we provide the insights and structure needed to scale profitably and make smarter business decisions.',
    icon: 'ri-line-chart-line'
  },
  {
    name: 'Elevation Ads',
    category: 'Digital Marketing',
    logo: 'https://vrdbmkseoo-staging.wpdns.site/wp-content/uploads/2025/11/2018logo.png',
    description: 'Elevation Ads specializes in digital marketing strategies tailored for medical practices looking to grow their patient base and stand out online. From SEO and Google Ads to email campaigns and high-converting websites, we focus on what drives measurable results.',
    icon: 'ri-megaphone-line'
  }
];

export default function PartnersGrid() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mb-4">
            <i className="ri-shield-check-line text-2xl text-[#e10708]"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Expert Partners Working Together</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Strengthen your practice with our network of trusted service providers
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="p-8">
                <div className="flex items-center justify-center h-32 mb-6 bg-gray-50 rounded-lg p-4">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#e10708] to-[#c00607] rounded-lg mb-4 mx-auto">
                  <i className={`${partner.icon} text-2xl text-white`}></i>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
                  {partner.name}
                </h3>
                
                <div className="inline-block px-3 py-1 bg-red-50 text-[#e10708] text-sm font-medium rounded-full mb-4 w-full text-center">
                  {partner.category}
                </div>

                <p className="text-gray-600 text-sm leading-relaxed">
                  {partner.description}
                </p>
              </div>

              <div className="px-8 pb-8">
                <div className="flex items-center justify-center text-[#e10708] font-medium group-hover:text-[#c00607] transition-colors whitespace-nowrap">
                  Learn More
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
